import { IExportColumnModel } from "../../../../../shared/models";

export const FieldClassificationColumnList: IExportColumnModel[] = [
]